// extracted by mini-css-extract-plugin
module.exports = {"DingTalkAuthWrapper":"DingTalkAuth_DingTalkAuthWrapper__5EiHP","DingTalkAuthFrame":"DingTalkAuth_DingTalkAuthFrame__f-pj9"};